<div class="checkbox-wrapper-55">
    <label class="rocker rocker-small">
        <input type="checkbox" [checked]="status == 1" (change)="toggleStatus()">
        <span class="switch-left">Yes</span>
      <span class="switch-right">No</span>
    </label>
</div>